'use strict';

module.exports = function(title, options) {
	if (!options) {
		options = {
			prependCk: false
		};
	}

	if (options.prependCk) {
		return `Code Kingdoms${title ? ` - ${title}` : ''}`;
	} else {
		return title;
	}
};
